import { MetricField } from "../../gql-generated/types";
import { getKeys } from "../../shared/utils/object";

export const metricsFields = [
    MetricField.LensUniques,
    MetricField.Subscribers,
    MetricField.LensPlays,
    MetricField.LensViews,
    MetricField.LensShares,
    MetricField.Favorites,
    MetricField.PlayTimeMillis,
    MetricField.UniqueSessions,
    MetricField.SwipeUps,
    MetricField.LensViewers,
    MetricField.LensLongPlays,
    MetricField.LensLongPlayRatio,
    MetricField.LensFaceFound,
    MetricField.LensFaceLost,
    MetricField.LensObjectTracked,
    MetricField.LensObjectTracked_3D,
    MetricField.LensMarkerTracked,
    MetricField.LensTap,
    MetricField.LensMultiuserSessionShared,
    MetricField.LensMultiuserSessionJoined,
    MetricField.LensPosts,
    MetricField.LensPosterUniques,
];

export const metricFieldsTotal = [
    MetricField.LensViewers,
    MetricField.LensUniques,
    MetricField.LensLongPlays,
    MetricField.LensLongPlayRatio,
    MetricField.LensFaceFound,
    MetricField.LensFaceLost,
    MetricField.LensObjectTracked,
    MetricField.LensObjectTracked_3D,
    MetricField.LensMarkerTracked,
    MetricField.LensTap,
    MetricField.LensMultiuserSessionShared,
    MetricField.LensMultiuserSessionJoined,
    MetricField.LensPosts,
    MetricField.LensPosterUniques,
];

// List of Metric Fields with Dimension Breakdowns

export const audienceFieldsWithDimensions = [MetricField.LensPlays, MetricField.LensViews];

export const funnelAnalysisFieldsWithDimensionsCascadingOrderMap: Partial<Record<MetricField, number>> = {
    [MetricField.LensViews]: 0,
    [MetricField.LensPlays]: 1,
    [MetricField.LensLongPlays]: 2,
    [MetricField.LensShares]: 3,
    [MetricField.Favorites]: 4,
};

export const funnelAnalysisFieldsWithDimensionsCascadingOrder: MetricField[] = getKeys(
    funnelAnalysisFieldsWithDimensionsCascadingOrderMap,
);
